"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("../01_atoms/RightPaneWidgetFrame"));

var _CovidInfoWidget = _interopRequireDefault(require("./CovidInfoWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CovidFormRightPane = function CovidFormRightPane(_ref) {
  var _ref$scrollTop = _ref.scrollTop,
      scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop,
      _ref$focusedLeftItemI = _ref.focusedLeftItemId,
      focusedLeftItemId = _ref$focusedLeftItemI === void 0 ? null : _ref$focusedLeftItemI,
      defaultValue = _ref.defaultValue,
      _ref$validateData = _ref.validateData,
      validateData = _ref$validateData === void 0 ? function () {
    return true;
  } : _ref$validateData,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
      translatorForNamespace = _ref.translatorForNamespace;
  return /*#__PURE__*/_react["default"].createElement(_RightPaneWidgetFrame["default"], {
    scrollTop: scrollTop,
    focusedLeftItemId: focusedLeftItemId
  }, /*#__PURE__*/_react["default"].createElement(_CovidInfoWidget["default"], {
    defaultValue: defaultValue,
    validateData: validateData,
    onSubmit: onSubmit,
    translatorForNamespace: translatorForNamespace
  }));
};

var _default = CovidFormRightPane;
exports["default"] = _default;